const Theme = {
  body_background_color: '#0F2A3F',
  title_font: 'Bison',
  text_font: 'CocoSharp',
  text_size: 18,
  subtitleH3_font_weight: '600',
  logo_image_url: 'canaldesoulanges.png',
  token_url: 'canaldesoulanges.png',
  number_hidden: true,
  number_font: 'Bison',
  number_color: 'white',
  header_full_height: true,
  header_no_margin: true,
  logo_height: 120,
  header_padding: 10,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 2,
  button_color: '#1CAABA',
  button_hover_text_color: '#1CAABA',
  button_radius: 10,
  button_outlined_border_color: '#1CAABA',
  button_outlined_hover_border_color: '#1CAABA'
}

export default Theme
